<div class="portfolio-page bg-[#F8FAFC] min-h-screen text-slate-800">

    <!-- HERO BANNER (Simple & Clean seperti About Us) -->
    <section
        class="relative overflow-hidden bg-gradient-to-br from-[#163861] via-[#1e4f87] to-[#1a6ea8] text-white pt-24 sm:pt-28 pb-12 sm:pb-16 px-4 sm:px-6 lg:px-8">
        <div class="max-w-4xl mx-auto text-center relative z-10">
            <!-- Label -->
            <h1
                class="text-3xl sm:text-4xl md:text-5xl font-extrabold text-white tracking-tight leading-tight mb-4 font-['Inter',sans-serif]">
                Portofolio Undangan Digital
            </h1>

            <p class="text-sm sm:text-base md:text-lg text-slate-200 max-w-2xl mx-auto font-normal leading-relaxed">
                Mereka yang Berbahagia dan Merayakannya Bersama Kami.
            </p>
        </div>

        <!-- Wave Transition -->
        <div class="absolute bottom-0 left-0 right-0 w-full overflow-hidden leading-none pointer-events-none">
            <svg viewBox="0 0 1440 40" preserveAspectRatio="none"
                class="w-full h-8 sm:h-10 text-[#F8FAFC] fill-current">
                <path d="M0,20 C360,40 1080,0 1440,20 L1440,40 L0,40 Z"></path>
            </svg>
        </div>
    </section>

    <!-- MAIN SHOWCASE CONTENT -->
    <main class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-14">

        <!-- LOADING SKELETON STATE -->
        <div *ngIf="isLoading" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            <div *ngFor="let s of [1,2,3,4,5,6]"
                class="bg-white rounded-3xl p-4 border border-slate-100 shadow-sm animate-pulse space-y-4">
                <div class="aspect-[4/5] bg-slate-200 rounded-2xl w-full"></div>
            </div>
        </div>

        <!-- EMPTY STATE -->
        <div *ngIf="!isLoading && filteredPortfolios.length === 0"
            class="text-center py-20 bg-white rounded-3xl border border-slate-200 p-8 max-w-xl mx-auto">
            <div
                class="w-20 h-20 mx-auto rounded-full bg-slate-100 text-slate-400 flex items-center justify-center text-3xl mb-4">
                🖼️
            </div>
            <h3 class="text-lg font-bold text-[#102B51]">Belum Ada Portofolio</h3>
            <p class="text-xs sm:text-sm text-slate-500 mt-1">
                Koleksi website undangan digital akan segera hadir.
            </p>
        </div>

        <!-- PORTFOLIO SHOWCASE GRID -->
        <div *ngIf="!isLoading && filteredPortfolios.length > 0"
            class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            <div *ngFor="let item of filteredPortfolios" (click)="openLiveDemo(item)"
                class="group cursor-pointer flex flex-col">

                <!-- Clean Image Container (No heavy background, pure image showcase) -->
                <div
                    class="relative w-full aspect-[4/3] sm:aspect-[4/3] rounded-2xl sm:rounded-3xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-500 border border-slate-100">
                    <img [src]="item.coverImage" [alt]="item.title" loading="lazy"
                        class="w-full h-full object-cover object-top transform group-hover:scale-105 transition-transform duration-500 ease-out">
                </div>

                <!-- Text Below Image (Only Title and Event Date) -->
                <div class="pt-3.5 px-1 flex flex-col">
                    <h3
                        class="text-base sm:text-lg font-bold text-[#102B51] group-hover:text-emerald-600 transition-colors leading-snug line-clamp-1 mb-1">
                        {{ item.title }}
                    </h3>
                    <p class="text-xs sm:text-sm text-slate-500 font-medium">
                        {{ item.eventDateFormatted }}
                    </p>
                </div>

            </div>
        </div>

    </main>

    <!-- LIVE PREVIEW & INTERACTIVE SIMULATOR MODAL -->
    <div *ngIf="isDetailModalOpen && selectedPortfolio"
        class="fixed inset-0 z-[120] flex items-center justify-center p-3 sm:p-4 md:p-6 bg-black/80 backdrop-blur-md animate-fade-in overflow-y-auto"
        (click)="closeDetailModal()">

        <div class="bg-white rounded-3xl max-w-4xl w-full max-h-[92vh] flex flex-col shadow-2xl border border-slate-200 my-auto overflow-hidden relative"
            (click)="$event.stopPropagation()">

            <!-- Modal Header -->
            <div class="p-5 sm:p-6 border-b border-slate-100 flex items-center justify-between shrink-0 bg-white">
                <div class="pr-6">
                    <div class="flex items-center gap-2 mb-1 flex-wrap">
                        <span
                            class="px-2.5 py-0.5 rounded-full text-[10px] font-extrabold uppercase bg-emerald-100 text-emerald-800">
                            Portofolio Live
                        </span>
                        <span *ngIf="selectedPortfolio.themed_product?.name"
                            class="px-2.5 py-0.5 rounded-full text-[10px] font-bold bg-indigo-100 text-indigo-800">
                            Tema: {{ selectedPortfolio.themed_product?.name }}
                        </span>
                        <span class="text-xs text-slate-400">📅 {{ selectedPortfolio.eventDateFormatted }}</span>
                    </div>
                    <h3 class="text-lg sm:text-2xl font-black text-[#102B51] tracking-tight">
                        {{ selectedPortfolio.title }}
                    </h3>
                </div>

                <!-- Close Button -->
                <button (click)="closeDetailModal()" aria-label="Tutup"
                    class="w-9 h-9 rounded-full bg-slate-100 hover:bg-slate-200 text-slate-600 flex items-center justify-center transition cursor-pointer shrink-0">
                    ✕
                </button>
            </div>

            <!-- View Switcher Bar (Mobile Simulator vs Desktop vs Galeri Foto) -->
            <div
                class="px-6 py-2.5 bg-slate-50 border-b border-slate-200 flex items-center justify-between gap-2 flex-wrap">
                <div class="flex items-center gap-1.5">
                    <button type="button" (click)="setPreviewMode('mobile')"
                        [ngClass]="previewMode === 'mobile' ? 'bg-[#202367] text-white shadow-xs' : 'bg-white text-slate-700 border border-slate-200 hover:bg-slate-100'"
                        class="px-3 py-1.5 rounded-xl text-xs font-bold transition flex items-center gap-1.5 cursor-pointer">
                        <span>📱</span>
                        <span>Simulator HP</span>
                    </button>

                    <button type="button" (click)="setPreviewMode('desktop')"
                        [ngClass]="previewMode === 'desktop' ? 'bg-[#202367] text-white shadow-xs' : 'bg-white text-slate-700 border border-slate-200 hover:bg-slate-100'"
                        class="px-3 py-1.5 rounded-xl text-xs font-bold transition flex items-center gap-1.5 cursor-pointer">
                        <span>💻</span>
                        <span>Desktop View</span>
                    </button>

                    <button type="button" (click)="setPreviewMode('gallery')"
                        [ngClass]="previewMode === 'gallery' ? 'bg-[#202367] text-white shadow-xs' : 'bg-white text-slate-700 border border-slate-200 hover:bg-slate-100'"
                        class="px-3 py-1.5 rounded-xl text-xs font-bold transition flex items-center gap-1.5 cursor-pointer">
                        <span>🖼️</span>
                        <span>Galeri Foto</span>
                    </button>
                </div>

                <!-- Direct Open External Link -->
                <button (click)="openLiveDemo(selectedPortfolio)"
                    class="text-xs font-bold text-emerald-700 hover:text-emerald-800 flex items-center gap-1 cursor-pointer">
                    <span>Buka URL Lengkap</span>
                    <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path>
                    </svg>
                </button>
            </div>

            <!-- Modal Scrollable Content Container -->
            <div class="p-6 overflow-y-auto flex-1 bg-slate-100/70 flex flex-col items-center justify-center">

                <!-- 1. MOBILE SMARTPHONE SIMULATOR -->
                <div *ngIf="previewMode === 'mobile'"
                    class="w-full max-w-sm flex flex-col items-center py-4 animate-fade-in">
                    <div
                        class="relative w-[340px] sm:w-[370px] h-[640px] sm:h-[680px] bg-slate-900 rounded-[44px] p-3 shadow-2xl border-4 border-slate-800 ring-8 ring-slate-900/40 flex flex-col overflow-hidden">
                        <!-- Speaker / Dynamic Island Top Notch -->
                        <div
                            class="absolute top-4 left-1/2 -translate-x-1/2 w-28 h-5 bg-black rounded-full z-30 flex items-center justify-center">
                            <div class="w-3 h-3 rounded-full bg-slate-800/80 mr-3"></div>
                            <div class="w-2.5 h-2.5 rounded-full bg-indigo-900/60"></div>
                        </div>

                        <!-- Iframe Live View Container -->
                        <div class="w-full h-full rounded-[34px] overflow-hidden bg-white relative">
                            <iframe *ngIf="safePreviewUrl" [src]="safePreviewUrl" class="w-full h-full border-0"
                                title="Mobile Wedding Invitation Preview" allow="autoplay; fullscreen">
                            </iframe>
                            <div *ngIf="!safePreviewUrl"
                                class="w-full h-full flex items-center justify-center p-6 text-center">
                                <img [src]="selectedPortfolio.coverImage" class="w-full h-full object-cover">
                            </div>
                        </div>
                    </div>
                    <p class="text-[11px] text-slate-500 mt-3 flex items-center gap-1 font-medium">
                        <span>👆</span> Anda dapat scroll dan berinteraksi langsung dengan website di dalam simulator.
                    </p>
                </div>

                <!-- 2. DESKTOP BROWSER SIMULATOR -->
                <div *ngIf="previewMode === 'desktop'" class="w-full max-w-3xl flex flex-col py-2 animate-fade-in">
                    <div class="rounded-2xl overflow-hidden border border-slate-300 bg-white shadow-2xl">
                        <!-- Browser Window Chrome Top Bar -->
                        <div class="px-4 py-2.5 bg-slate-200 border-b border-slate-300 flex items-center gap-2">
                            <div class="flex items-center gap-1.5">
                                <span class="w-3 h-3 rounded-full bg-rose-400 inline-block"></span>
                                <span class="w-3 h-3 rounded-full bg-amber-400 inline-block"></span>
                                <span class="w-3 h-3 rounded-full bg-emerald-400 inline-block"></span>
                            </div>
                            <div
                                class="flex-1 max-w-md mx-auto bg-white px-3 py-1 rounded-lg text-[11px] font-mono text-slate-600 truncate border border-slate-200 text-center">
                                🔒 {{ selectedPortfolio.product_link }}
                            </div>
                        </div>

                        <!-- Iframe Desktop Container -->
                        <div class="w-full h-[520px] bg-slate-50 relative">
                            <iframe *ngIf="safePreviewUrl" [src]="safePreviewUrl" class="w-full h-full border-0"
                                title="Desktop Wedding Invitation Preview" allow="autoplay; fullscreen">
                            </iframe>
                        </div>
                    </div>
                </div>

                <!-- 3. GALLERY PHOTO SCREENSHOTS -->
                <div *ngIf="previewMode === 'gallery'" class="w-full max-w-2xl py-2 animate-fade-in space-y-4">
                    <div
                        class="relative h-80 sm:h-96 rounded-2xl overflow-hidden bg-slate-900 border border-slate-200 shadow-md">
                        <img [src]="selectedPortfolio.images[activeGalleryImageIndex]?.url || selectedPortfolio.coverImage"
                            class="w-full h-full object-contain">
                    </div>

                    <!-- Thumbnails List -->
                    <div *ngIf="selectedPortfolio.images.length > 1"
                        class="flex items-center gap-2 overflow-x-auto pb-2">
                        <button *ngFor="let img of selectedPortfolio.images; let idx = index"
                            (click)="activeGalleryImageIndex = idx"
                            [ngClass]="activeGalleryImageIndex === idx ? 'ring-2 ring-[#202367] border-transparent' : 'opacity-70 hover:opacity-100 border-slate-200'"
                            class="w-16 h-16 rounded-xl overflow-hidden border shrink-0 transition cursor-pointer">
                            <img [src]="img.url" class="w-full h-full object-cover">
                        </button>
                    </div>
                </div>

            </div>

            <!-- Modal Footer Actions -->
            <div
                class="p-5 sm:p-6 border-t border-slate-100 flex flex-col sm:flex-row items-center justify-between gap-4 bg-white shrink-0">
                <div class="text-xs text-slate-500 text-center sm:text-left">
                    Tertarik dengan desain & konsep web undangan <strong class="text-[#102B51]">{{
                        selectedPortfolio.client_name }}</strong>?
                </div>

                <div class="flex items-center gap-3 w-full sm:w-auto">
                    <button type="button" (click)="consultWhatsApp(selectedPortfolio)"
                        class="flex-1 sm:flex-none py-3 px-5 rounded-xl border border-emerald-600 bg-emerald-50 hover:bg-emerald-100 text-emerald-700 text-xs sm:text-sm font-bold transition flex items-center justify-center gap-2 cursor-pointer">
                        <span>💬 Konsultasi WA</span>
                    </button>
                    <button type="button" (click)="goToDigitalInvitationOrder(selectedPortfolio)"
                        class="flex-1 sm:flex-none py-3 px-6 rounded-xl bg-gradient-to-r from-[#202367] to-[#102B51] hover:from-[#191c53] hover:to-[#091b33] text-white text-xs sm:text-sm font-bold shadow-lg transition flex items-center justify-center gap-2 cursor-pointer active:scale-95">
                        <span>Pesan Desain Undangan</span>
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M14 5l7 7m0 0l-7 7m7-7H3" />
                        </svg>
                    </button>
                </div>
            </div>

        </div>
    </div>
</div>